import * as React from 'react'
import { connect } from 'react-redux'
import YouTube from 'react-youtube'
import * as events from '../../../events'
import { VideoContainer } from './styles'

type OrientationVideoProps = {
  trackTappedHowToDashVideo: () => Promise<any>
}
export const OrientationVideo: React.SFC<OrientationVideoProps> = props => (
  <VideoContainer>
    <YouTube
      videoId="wXL9ENfKNmc"
      opts={{
        playerVars: {
          rel: '0',
          controls: '0',
        },
      }}
      onPlay={props.trackTappedHowToDashVideo}
    />
  </VideoContainer>
)

const mapDispatchToProps = {
  trackTappedHowToDashVideo: events.trackTappedHowToDashVideo,
}
export default connect(null, mapDispatchToProps)(OrientationVideo)
